import { __decorate, __metadata, __param } from "tslib";
import { format } from '@/@core/utils/string';
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
let HistroyApi = class HistroyApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        /* 获取历史信息  公司-账号 */
        this.getHistoryList = (company_id, params) => {
            const url = format(this.urls.getHistoryList, {
                company_id,
            });
            return this.http.get({
                url,
                params,
            });
        };
    }
};
HistroyApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.HistoryApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], HistroyApi);
export { HistroyApi };
